module.exports = __webpack_public_path__ + "static/media/email.7430cb2f.svg";